import React from 'react';
import { IndustryResearchReport } from '@/interface/report';
import ChartHeader from '../chart-header';
import Chart from '../chart';
import ReportCard from '../ReportCard';
import styles from './index.module.scss';

export type ReportGalleryProps = {
  reportList?: IndustryResearchReport[];
};

const ReportGallery: React.FC<ReportGalleryProps> = ({ reportList = [] }) => {
  return (
    <>
      <ChartHeader
        title="行业热门报告"
        titleFontSize={20}
        className={styles.reportChartHeader}
        extra={
          <a className={styles.brandExtra} href="/report" target="_blank">
            查看更多
            <svg className="icon" aria-hidden="true">
              <use xlinkHref="#icon-double_chevron_right_black" />
            </svg>
          </a>
        }
      />
      <Chart header={false} panelClassName={styles.reportListChart}>
        {reportList.map(item => {
          return (
            <ReportCard
              key={item.id}
              id={item.id}
              reportId={item.id}
              cover={item.image}
              title={item.title}
              createTime={item.date}
              updateTime={item.date}
              hottest={item.hottest}
              latest={item.latest}
              preSell={item.preSell}
              referenced={item.referenced}
              clickTimes={item.clickTimes}
              type={item.type}
            />
          );
        })}
      </Chart>
    </>
  );
};

export default ReportGallery;
